import React, { useEffect } from 'react';
import StyledNotifications from 'hyarchis-global/components/notifications/StyledNotifications';
import TopBarContainer from 'components/top-bar';
import { HyarchisGlobalStyle } from 'hyarchis-global';
import styled from 'styled-components';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import { useActions, useShallowSelector } from 'hooks';
import { loadDataExtractionDefinitionsAction } from 'store/dataExtractionDefinitions/actions';
import { ApplicationState } from 'store/types';
import Drawers from './drawers';
import ProcessingJobsContainer from './processing-jobs';
import DocumentGroupContainer from './documents-groups';

const Wrapper = styled.div`
  height: calc(100% - ${(props) => props.theme.sizes.topBarHeight}px);
`;

const Root = () => {
  const { auth } = useShallowSelector((app: ApplicationState) => ({ auth: app.auth }));

  const { loadDataExtractionDefinitions } = useActions({
    loadDataExtractionDefinitions: loadDataExtractionDefinitionsAction,
  });

  useEffect(() => {
    if (auth?.accessToken) {
      loadDataExtractionDefinitions();
    }
  }, [auth, loadDataExtractionDefinitions]);

  return (
    <Wrapper>
      <Router>
        <TopBarContainer />
        <HyarchisGlobalStyle />
        <StyledNotifications />
        <Drawers />
        <Routes>
          <Route path='/documentsGroups' element={<DocumentGroupContainer />} />
          <Route path='/' element={<ProcessingJobsContainer />} />
        </Routes>
      </Router>
    </Wrapper>
  );
};

export default React.memo(Root);
